import { Injectable } from '@angular/core';
import { NotificationSnackComponent } from '../components/notificationSnack/notificationSnack.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as constants from '../constants/constants';


@Injectable({
  providedIn: 'root'
})

export class SnackBarService {

  constructor(private snackBar: MatSnackBar) { }

  openInfo(message: string, duration: number = constants.snackBarDurationInSeconds) {
    this.snackBar.openFromComponent(NotificationSnackComponent, {
      duration: duration * 1000, panelClass: ['snackbar-info'], data: { message: message }
    });
  }

  openSuccess(message: string, duration: number = constants.snackBarDurationInSeconds) {
    this.snackBar.openFromComponent(NotificationSnackComponent, {
      duration: duration * 1000, panelClass: ['snackbar-success'], data: { message: message }
    });
  }

  openError(message: string, duration: number = constants.snackBarDurationInSeconds) {
    this.snackBar.openFromComponent(NotificationSnackComponent, {
      duration: duration * 1000, panelClass: ['snackbar-error'], data: { message: message }
    });
  }

  
}
